var _a;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { requestTiers, requestTiersFailure, requestTiersSuccess, } from './actions';
var reducers = handleActions((_a = {},
    _a[requestTiers.toString()] = function (state) { return (__assign(__assign({}, state), { requestStatus: 'fetching' })); },
    _a[requestTiersSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'idle', tiers: action.payload.tiers })); },
    _a[requestTiersFailure.toString()] = function (state, action) { return (__assign(__assign({}, state), { requestStatus: 'error', errorMessage: action.payload.error })); },
    _a), {
    tiers: [],
    requestStatus: 'idle',
});
export default reducers;
//# sourceMappingURL=tierListReducer.js.map